import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Transportation.css";

import {
  logHistory
} from "../../utils/historyLogger";

function Transportation() {
  const [hiredVehicles, setHiredVehicles] = useState([]);
  const [companyVehicles, setCompanyVehicles] = useState([]);
  const [search, setSearch] = useState("");

  const role = localStorage.getItem("role");

  const canEdit = role === "admin" || role === "superadmin";
  const canDelete = role === "superadmin";
  // Any logged-in role (user, admin, superadmin) can add data now.
  const canAdd = role === "user" || role === "admin" || role === "superadmin";

  const [editingHiredId, setEditingHiredId] = useState(null);
  const [editingCompanyId, setEditingCompanyId] = useState(null);

  const [hiredForm, setHiredForm] = useState({
    date: "",
    vehicleNumber: "",
    vehicleType: "",
    companyName: "",
    reason: "",
    driverName: "",
    contactNumber: "",
    inTime: "",
    cost: "",
    department: "",
    remarks: "",
    status: "Pending",
  });

  const [companyForm, setCompanyForm] = useState({
    date: "",
    vehicleNumber: "",
    vehicleType: "",
    startingPoint: "",
    destination: "",
    inTime: "",
    outTime: "",
    driverName: "",
    category: "",
    remarks: "",
    status: "Pending",
  });

  useEffect(() => {
    fetchHiredVehicles();
    fetchCompanyVehicles();
  }, []);

  const fetchHiredVehicles = async () => {
    try {
      const res = await axios.get("https://hrpsc.swisstekaluminium.com/api/transport/hired");
      setHiredVehicles(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchCompanyVehicles = async () => {
    try {
      const res = await axios.get("https://hrpsc.swisstekaluminium.com/api/transport/company");
      setCompanyVehicles(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.log(err);
    }
  };

  const handleHiredChange = (e) => {
    setHiredForm({
      ...hiredForm,
      [e.target.name]: e.target.value,
    });
  };

  const handleCompanyChange = (e) => {
    setCompanyForm({
      ...companyForm,
      [e.target.name]: e.target.value,
    });
  };

  const clearHiredForm = () => {
    setHiredForm({
      date: "",
      vehicleNumber: "",
      vehicleType: "",
      companyName: "",
      reason: "",
      driverName: "",
      contactNumber: "",
      inTime: "",
      cost: "",
      department: "",
      remarks: "",
      status: "Pending",
    });

    setEditingHiredId(null);
  };

  const clearCompanyForm = () => {
    setCompanyForm({
      date: "",
      vehicleNumber: "",
      vehicleType: "",
      startingPoint: "",
      destination: "",
      inTime: "",
      outTime: "",
      driverName: "",
      category: "",
      remarks: "",
      status: "Pending",
    });

    setEditingCompanyId(null);
  };
    const handleHiredSubmit = async () => {
    if (!hiredForm.vehicleNumber) {
      alert("Vehicle Number is required");
      return;
    }

    try {
      const payload = {
        date: hiredForm.date || "",
        vehicleNo: hiredForm.vehicleNumber || "",
        vehicleType: hiredForm.vehicleType || "",
        companyName: hiredForm.companyName || "",
        reason: hiredForm.reason || "",
        driverName: hiredForm.driverName || "",
        contactNumber: hiredForm.contactNumber || "",
        inTime: hiredForm.inTime || "",
        cost: hiredForm.cost || "",
        department: hiredForm.department || "",
        remarks: hiredForm.remarks || "",
        status: hiredForm.status || "Pending",
      };

      if (editingHiredId) {
        await axios.put(
          `https://hrpsc.swisstekaluminium.com/api/transport/hired/${editingHiredId}`,
          payload
        );

        await logHistory(
          "Transportation",
          "Updated Hired Vehicle",
          `Vehicle ${hiredForm.vehicleNumber} updated`
        );

        alert("Updated Successfully");
      } else {
        await axios.post("https://hrpsc.swisstekaluminium.com/api/transport/hired", payload);

        await logHistory(
          "Transportation",
          "Added Hired Vehicle",
          `Vehicle ${hiredForm.vehicleNumber} added`
        );

        alert("Vehicle Added");
      }

      fetchHiredVehicles();
      clearHiredForm();
    } catch (err) {
      console.log(err);
      alert(err.response?.data?.message || "Error Saving Vehicle");
    }
  };

  const handleCompanySubmit = async () => {
    if (!companyForm.vehicleNumber) {
      alert("Vehicle Number is required");
      return;
    }

    try {
      const payload = {
        date: companyForm.date || "",
        vehicleNo: companyForm.vehicleNumber || "",
        vehicleType: companyForm.vehicleType || "",
        startingPoint: companyForm.startingPoint || "",
        destination: companyForm.destination || "",
        inTime: companyForm.inTime || "",
        outTime: companyForm.outTime || "",
        driverName: companyForm.driverName || "",
        category: companyForm.category || "",
        remarks: companyForm.remarks || "",
        status: companyForm.status || "Pending",
      };

      if (editingCompanyId) {
        await axios.put(
          `https://hrpsc.swisstekaluminium.com/api/transport/company/${editingCompanyId}`,
          payload
        );

        await logHistory(
          "Transportation",
          "Updated Company Vehicle",
          `Vehicle ${companyForm.vehicleNumber} updated`
        );

        alert("Updated Successfully");
      } else {
        await axios.post("https://hrpsc.swisstekaluminium.com/api/transport/company", payload);

        await logHistory(
          "Transportation",
          "Added Company Vehicle",
          `Vehicle ${companyForm.vehicleNumber} added`
        );

        alert("Vehicle Added");
      }

      fetchCompanyVehicles();
      clearCompanyForm();
    } catch (err) {
      console.log(err);
      alert(err.response?.data?.message || "Error Saving Vehicle");
    }
  };

  const deleteHiredVehicle = async (id) => {
    if (!window.confirm("Delete this hired vehicle?")) return;

    try {
      await axios.delete(`https://hrpsc.swisstekaluminium.com/api/transport/hired/${id}`);

      await logHistory(
        "Transportation",
        "Deleted Hired Vehicle",
        "Hired vehicle deleted"
      );

      fetchHiredVehicles();
    } catch (err) {
      console.log(err);
      alert("Delete Failed");
    }
  };

  const deleteCompanyVehicle = async (id) => {
    if (!window.confirm("Delete this company vehicle?")) return;

    try {
      await axios.delete(`https://hrpsc.swisstekaluminium.com/api/transport/company/${id}`);

      await logHistory(
        "Transportation",
        "Deleted Company Vehicle",
        "Company vehicle deleted"
      );

      fetchCompanyVehicles();
    } catch (err) {
      console.log(err);
      alert("Delete Failed");
    }
  };
    const editHiredVehicle = (item) => {
    setEditingHiredId(item.id);

    setHiredForm({
      date: item.date || "",
      vehicleNumber: item.vehicleNo || item.vehicleNumber || "",
      vehicleType: item.vehicleType || "",
      companyName: item.companyName || "",
      reason: item.reason || "",
      driverName: item.driverName || "",
      contactNumber: item.contactNumber || "",
      inTime: item.inTime || "",
      cost: item.cost || "",
      department: item.department || "",
      remarks: item.remarks || "",
      status: item.status || "Pending",
    });

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const editCompanyVehicle = (item) => {
    setEditingCompanyId(item.id);

    setCompanyForm({
      date: item.date || "",
      vehicleNumber: item.vehicleNo || item.vehicleNumber || "",
      vehicleType: item.vehicleType || "",
      startingPoint: item.startingPoint || "",
      destination: item.destination || "",
      inTime: item.inTime || "",
      outTime: item.outTime || "",
      driverName: item.driverName || "",
      category: item.category || "",
      remarks: item.remarks || "",
      status: item.status || "Pending",
    });

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const toggleHiredStatus = async (id, currentStatus) => {
    try {
      const updatedStatus =
        currentStatus === "Pending" ? "Completed" : "Pending";

      const selected = hiredVehicles.find((item) => item.id === id);

      await axios.put(`https://hrpsc.swisstekaluminium.com/api/transport/hired/${id}`, {
        ...selected,
        status: updatedStatus,
      });

      await logHistory(
        "Transportation",
        "Updated Hired Vehicle Status",
        `Vehicle status changed to ${updatedStatus}`
      );

      fetchHiredVehicles();
    } catch (err) {
      console.log(err);
      alert("Status Update Failed");
    }
  };

  const toggleCompanyStatus = async (id, currentStatus) => {
    try {
      const updatedStatus =
        currentStatus === "Pending" ? "Completed" : "Pending";

      const selected = companyVehicles.find((item) => item.id === id);

      await axios.put(`https://hrpsc.swisstekaluminium.com/api/transport/company/${id}`, {
        ...selected,
        status: updatedStatus,
      });

      await logHistory(
        "Transportation",
        "Updated Company Vehicle Status",
        `Vehicle status changed to ${updatedStatus}`
      );

      fetchCompanyVehicles();
    } catch (err) {
      console.log(err);
      alert("Status Update Failed");
    }
  };

  const downloadCSVReport = (data, filename) => {
    if (!data || data.length === 0) {
      alert("No data to download");
      return;
    }

    const headers = Object.keys(data[0]);

    const rows = data.map((item) =>
      headers
        .map((field) => `"${String(item[field] ?? "").replace(/"/g, '""')}"`)
        .join(",")
    );

    const csvContent = [headers.join(","), ...rows].join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.click();

    URL.revokeObjectURL(url);
  };

  const filteredHiredVehicles = hiredVehicles.filter((item) =>
    (item.vehicleNo || item.vehicleNumber || "")
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  const filteredCompanyVehicles = companyVehicles.filter((item) =>
    (item.vehicleNo || item.vehicleNumber || "")
      .toLowerCase()
      .includes(search.toLowerCase())
  );
    return (
    <div className="page-container">
      <h1 className="page-title">Transportation</h1>

      <div className="cards">
        <div className="card">
          <h3>Hired Vehicles</h3>
          <p>{hiredVehicles.length}</p>
        </div>

        <div className="card">
          <h3>Company Vehicles</h3>
          <p>{companyVehicles.length}</p>
        </div>
      </div>

      <div className="search-section">
        <input
          type="text"
          className="search-input"
          placeholder="Search Vehicle Number..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <button className="clear-btn" onClick={() => setSearch("")}>
          Clear
        </button>

        <button
          className="primary-btn"
          onClick={() =>
            downloadCSVReport(hiredVehicles, "hired_vehicles_report.csv")
          }
        >
          Download Hired Report
        </button>

        <button
          className="primary-btn"
          onClick={() =>
            downloadCSVReport(companyVehicles, "company_vehicles_report.csv")
          }
        >
          Download Company Report
        </button>
      </div>

      <div className="table-container">
        <h2 className="section-title">Hired Vehicles</h2>

        {(canAdd || editingHiredId) && (
          <>
            <div className="form-grid">
              <input type="date" name="date" value={hiredForm.date} onChange={handleHiredChange} />
              <input type="text" name="vehicleNumber" placeholder="Vehicle Number *" value={hiredForm.vehicleNumber} onChange={handleHiredChange} />
              <input type="text" name="vehicleType" placeholder="Vehicle Type" value={hiredForm.vehicleType} onChange={handleHiredChange} />
              <input type="text" name="companyName" placeholder="Company Name" value={hiredForm.companyName} onChange={handleHiredChange} />
              <input type="text" name="reason" placeholder="Reason" value={hiredForm.reason} onChange={handleHiredChange} />
              <input type="text" name="driverName" placeholder="Driver Name" value={hiredForm.driverName} onChange={handleHiredChange} />
              <input type="text" name="contactNumber" placeholder="Contact Number" value={hiredForm.contactNumber} onChange={handleHiredChange} />
              <input type="time" name="inTime" value={hiredForm.inTime} onChange={handleHiredChange} />
              <input type="text" name="cost" placeholder="Cost" value={hiredForm.cost} onChange={handleHiredChange} />
              <input type="text" name="department" placeholder="Department" value={hiredForm.department} onChange={handleHiredChange} />
              <input type="text" name="remarks" placeholder="Remarks" value={hiredForm.remarks} onChange={handleHiredChange} />
            </div>

            <div className="button-group">
              <button className="primary-btn" onClick={handleHiredSubmit}>
                {editingHiredId ? "Update Vehicle" : "Add Vehicle"}
              </button>

              <button className="clear-btn" onClick={clearHiredForm}>
                Clear Form
              </button>
            </div>
          </>
        )}

        <table className="custom-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Vehicle No</th>
              <th>Type</th>
              <th>Company</th>
              <th>Reason</th>
              <th>Driver</th>
              <th>Contact</th>
              <th>In Time</th>
              <th>Cost</th>
              <th>Department</th>
              <th>Remarks</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredHiredVehicles.map((item) => (
              <tr key={item.id}>
                <td>{item.date}</td>
                <td>{item.vehicleNo || item.vehicleNumber}</td>
                <td>{item.vehicleType}</td>
                <td>{item.companyName}</td>
                <td>{item.reason}</td>
                <td>{item.driverName}</td>
                <td>{item.contactNumber}</td>
                <td>{item.inTime}</td>
                <td>{item.cost}</td>
                <td>{item.department}</td>
                <td>{item.remarks}</td>

                <td>
                  {canEdit ? (
                    <button
                      className={
                        item.status === "Completed"
                          ? "completed-status"
                          : "pending-status"
                      }
                      onClick={() => toggleHiredStatus(item.id, item.status)}
                    >
                      {item.status}
                    </button>
                  ) : (
                    <span
                      className={
                        item.status === "Completed"
                          ? "completed-status"
                          : "pending-status"
                      }
                    >
                      {item.status}
                    </span>
                  )}
                </td>

                <td>
                  <div className="action-buttons">
                    {canEdit && (
                      <button className="edit-btn" onClick={() => editHiredVehicle(item)}>
                        Edit
                      </button>
                    )}

                    {canDelete && (
                      <button className="delete-btn" onClick={() => deleteHiredVehicle(item.id)}>
                        Delete
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="table-container">
        <h2 className="section-title">Company Vehicles</h2>

        {(canAdd || editingCompanyId) && (
          <>
            <div className="form-grid">
              <input type="date" name="date" value={companyForm.date} onChange={handleCompanyChange} />
              <input type="text" name="vehicleNumber" placeholder="Vehicle Number *" value={companyForm.vehicleNumber} onChange={handleCompanyChange} />
              <input type="text" name="vehicleType" placeholder="Vehicle Type" value={companyForm.vehicleType} onChange={handleCompanyChange} />
              <input type="text" name="startingPoint" placeholder="Starting Point" value={companyForm.startingPoint} onChange={handleCompanyChange} />
              <input type="text" name="destination" placeholder="Destination" value={companyForm.destination} onChange={handleCompanyChange} />
              <input type="time" name="inTime" value={companyForm.inTime} onChange={handleCompanyChange} />
              <input type="time" name="outTime" value={companyForm.outTime} onChange={handleCompanyChange} />
              <input type="text" name="driverName" placeholder="Driver Name" value={companyForm.driverName} onChange={handleCompanyChange} />
              <input type="text" name="category" placeholder="Category" value={companyForm.category} onChange={handleCompanyChange} />
              <input type="text" name="remarks" placeholder="Remarks" value={companyForm.remarks} onChange={handleCompanyChange} />
            </div>

            <div className="button-group">
              <button className="primary-btn" onClick={handleCompanySubmit}>
                {editingCompanyId ? "Update Vehicle" : "Add Vehicle"}
              </button>

              <button className="clear-btn" onClick={clearCompanyForm}>
                Clear Form
              </button>
            </div>
          </>
        )}

        <table className="custom-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Vehicle No</th>
              <th>Type</th>
              <th>Starting</th>
              <th>Destination</th>
              <th>In Time</th>
              <th>Out Time</th>
              <th>Driver</th>
              <th>Category</th>
              <th>Remarks</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredCompanyVehicles.map((item) => (
              <tr key={item.id}>
                <td>{item.date}</td>
                <td>{item.vehicleNo || item.vehicleNumber}</td>
                <td>{item.vehicleType}</td>
                <td>{item.startingPoint}</td>
                <td>{item.destination}</td>
                <td>{item.inTime}</td>
                <td>{item.outTime}</td>
                <td>{item.driverName}</td>
                <td>{item.category}</td>
                <td>{item.remarks}</td>

                <td>
                  {canEdit ? (
                    <button
                      className={
                        item.status === "Completed"
                          ? "completed-status"
                          : "pending-status"
                      }
                      onClick={() => toggleCompanyStatus(item.id, item.status)}
                    >
                      {item.status}
                    </button>
                  ) : (
                    <span
                      className={
                        item.status === "Completed"
                          ? "completed-status"
                          : "pending-status"
                      }
                    >
                      {item.status}
                    </span>
                  )}
                </td>

                <td>
                  <div className="action-buttons">
                    {canEdit && (
                      <button className="edit-btn" onClick={() => editCompanyVehicle(item)}>
                        Edit
                      </button>
                    )}

                    {canDelete && (
                      <button className="delete-btn" onClick={() => deleteCompanyVehicle(item.id)}>
                        Delete
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Transportation;